import 'react-toastify/dist/ReactToastify.css'
import './app.scss'
import { lazy, Suspense } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router'
import { ToastContainer } from 'react-toastify'
import { LCRouteLoader } from './app/ui/components/lc-route-loader/LCRouteLoader'
import { LCTrialExpirationOverlay } from './app/ui/components/lc-trial-expiration-overlay/LCTrialExpirationOverlay'
import { LCTrialGuard } from './app/ui/components/lc-trial-guard/LCTrialGuard'
import { LCSmartlook } from './app/utils/smartlook/LCSmartlook'
import { useAppSelector } from './app/redux/hooks'
import { selectGeneral } from './app/redux/reducers/generalSlice'
import { PublicRoutes } from './app/routes/PublicRoutes'
import { LCClientErrorCodeNotification } from './app/ui/components/lc-notification/LCClientErrorCodeNotification'

const MainLayout = lazy(() => import('./app/layout/MainLayout'))

// @lat: [[overview#Admin overview]]
const App = (): JSX.Element => {
  const clientErrorCode = useAppSelector(selectGeneral).clientErrorCode

  return (
    <div className="app">
      {/* <LCSocket /> */}
      <ToastContainer />
      <LCClientErrorCodeNotification code={clientErrorCode} />

      <BrowserRouter>
        <LCSmartlook />
        <Routes>
          <Route path="/*" element={<PublicRoutes />} />
          <Route
            path="/app/*"
            element={
              <LCTrialGuard>
                <LCTrialExpirationOverlay>
                  <Suspense fallback={<LCRouteLoader />}>
                    <MainLayout />
                  </Suspense>
                </LCTrialExpirationOverlay>
              </LCTrialGuard>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  )
}

export default App
